import React from "react";
import Select from "react-select";
import InvalidFeedback from "./InvalidFeedback";

const FormGroupSelect = (props) => {
    const {
        isDisabled = false,
        name,
        onChange,
        options,
        placeholder,
        value,
        label,
        error,
    } = props;
    return (
        <div className="form-group mb-2">
            {!!label &&
                <label className="mb-1 font-weight-bold">{label}</label>
            }
            <Select
                isDisabled={isDisabled}
                name={name}
                value={value}
                onChange={onChange}
                options={options}
                placeholder={placeholder}
                styles={{
                    control: (provided, state) => (!!error ? {
                        ...provided, borderColor: 'red',
                    } : provided)
                }}
                className={`w-100 ${!!error ? 'is-invalid' : ''}`}
                autoComplete="chrome-off"
                {...props}
            />
            <InvalidFeedback error={error}/>
        </div>
    )
}


export default FormGroupSelect;
